export default "__VITE_ASSET__82KaO5jk__"